"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = __importStar(require("@rws-framework/client"));
const trans_1 = require("../../../../common/translations/trans");
const currencies_1 = require("../../../../common/translations/currencies");
const translations_1 = require("./translations");
String.prototype.capitalize = function () {
    if (!this || this.length === 0)
        return '';
    return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
};
String.prototype.t = function (params) {
    return (0, trans_1.translate)(this, (0, translations_1.getLanguage)() || 'en', params);
};
String.prototype.currency = function () {
    if (localStorage.getItem('rws_currency_rate') === null || localStorage.getItem('rws_currency_rate') === undefined) {
        return 'usd';
    }
    if (Object.keys(currencies_1.currencies).indexOf((0, translations_1.getLanguage)() || 'en') === -1) {
        return this;
    }
    return (0, trans_1.getCurrency)((0, translations_1.getLanguage)() || 'en');
};
Number.prototype.currencyConvert = function (from, to = null) {
    if (localStorage.getItem('rws_currency_rate') === null || localStorage.getItem('rws_currency_rate') === undefined) {
        return 1;
    }
    const lang = (0, translations_1.getLanguage)() || 'en';
    if (lang === 'en') {
        return this;
    }
    if (to === null) {
        to = (0, trans_1.getCurrency)(lang);
    }
    return Number(localStorage.getItem('rws_currency_rate')) * this;
};
String.prototype.thumb = function (index) {
    const theClient = (0, client_1.RWSContainer)().get(client_1.default);
    const backendUrl = theClient.getConfig().get('backendUrl') || '';
    let res = this;
    if (res.startsWith('/')) {
        res = res.substring(1);
    }
    return `${backendUrl}/image/${res}?index=${index}`;
};
